export const STATUS_NONAKTIF = 0;
export const STATUS_AKTIF = 1;
export const STATUS_ARSIP = 2;

export default {
  STATUS_AKTIF,
  STATUS_NONAKTIF,
  STATUS_ARSIP
};
